import { render, staticRenderFns } from "./TerminateModal.vue?vue&type=template&id=1050f076&lang=pug"
import script from "./TerminateModal.vue?vue&type=script&lang=ts"
export * from "./TerminateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports